'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _numeral = require('numeral');
var _numeral2 = _interopRequireDefault(_numeral);
var _dotstatsuiteD3Charts = require('@sis-cc/dotstatsuite-d3-charts');
var _src = require('../../../bridge-d3-react/src');
var _styles = require('@material-ui/core/styles');
var _AxisLegend = require('./AxisLegend');
var _AxisLegend2 = _interopRequireDefault(_AxisLegend);
var _FocusLegend = require('./FocusLegend');
var _FocusLegend2 = _interopRequireDefault(_FocusLegend);
var _SeriesLegend = require('./SeriesLegend');
var _SeriesLegend2 = _interopRequireDefault(_SeriesLegend);
var _constants = require('../../../rules/src/constants');
var _utils = require('../utils');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ChoroLegend = function ChoroLegend(_ref) {
  var type = _ref.type,
    options = _ref.options,
    data = _ref.data;
  if (type !== _constants.CHORO) {
    return null;
  }
  var theme = (0, _styles.useTheme)();
  var fontOptions = R.pipe((0, _utils.getFontFromTheme)(['mapLegend']), _utils.getOptionsFromFont)(theme);
  var legendOptions = R.mergeDeepLeft(options, {
    legend: {
      choropleth: {
        width: 300,
        height: 30,
        margin: {
          left: 15,
          right: 15
        },
        axis: {
          thickness: 0,
          orient: 'bottom',
          font: fontOptions,
          tick: {
            size: 5,
            thickness: 0
          },
          format: {
            proc: function proc(d) {
              return (0, _numeral2.default)(d).format('0,0.[00]');
            }
          }
        }
      }
    }
  });
  return _react2.default.createElement(_src.ChoroplethLegend, {
    options: legendOptions,
    data: data.series
  });
};
var ChartLegends = function ChartLegends(_ref2) {
  var data = _ref2.data,
    options = _ref2.options,
    type = _ref2.type,
    width = _ref2.width;
  var engineOptions = R.pipe(R.assocPath(['serie', 'stacked', 'layerSeries'], R.pathOr([], ['series', 0, 'layerSeries'], data)), _dotstatsuiteD3Charts.computeOptions)(options);
  return _react2.default.createElement('div', null, _react2.default.createElement(_AxisLegend2.default, {
    axis: 'x',
    data: data,
    type: type
  }), _react2.default.createElement(_FocusLegend2.default, {
    data: data,
    options: engineOptions,
    type: type,
    width: width
  }), _react2.default.createElement(_SeriesLegend2.default, {
    data: data,
    options: engineOptions,
    type: type
  }), _react2.default.createElement(ChoroLegend, {
    data: data,
    options: options,
    type: type
  }));
};
exports.default = ChartLegends;